/**
 * Root element class string for popup overlays (same look as `.modal` in `layout.css`).
 * Pass `true` when the popup should appear: adds `show` plus `d-block` so it actually renders—our CSS hides `.modal`
 * until then.
 */
export function modalRootClassName(isOpen, { staticBackdrop = false } = {}) {
  return ['modal', 'fade', staticBackdrop ? 'modal-static' : '', isOpen ? 'show d-block' : ''].filter(Boolean).join(' ');
}
